import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".D6lCq{color:var(--ricos-settings-text-color,#000);text-decoration:underline}@media only screen and (max-width:640px){[data-query=media] .D6lCq{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464))}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .D6lCq{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464))}}}@container (width < 640px){[data-query=container] .D6lCq{color:var(--ricos-settings-text-color,var(--ricos-text-color-low,#646464))}}";
var styles = {"learn_more_link":"D6lCq"};
styleInject(css_248z);

const MoreLink = ({ link, t }) => /* @__PURE__ */ React.createElement("a", { className: styles.learn_more_link, target: "_blank", href: link, rel: "noreferrer" }, t("LinkPanel_Learn_More_Label"));

export { MoreLink as default };
//# sourceMappingURL=MoreLink.js.map
